import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { Bound } from '@fcom/dapi/api/models';

@Component({
  selector: 'fin-flight-selection-flight-summary',
  templateUrl: './flight-summary.component.html',
  styleUrls: ['./flight-summary.component.scss'],
  standalone: false,
})
export class FlightSelectionFlightSummaryComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input() listStyle: 'ordered' | 'departure-return' = 'departure-return';
  @Input({ required: true }) bounds: Observable<Bound[]>;
  @Output() clickedBound = new EventEmitter<{
    bound: Bound;
    index: number;
  }>();
}
